import { render, staticRenderFns } from "./ThreadItem.vue?vue&type=template&id=6567b2b3&scoped=true&"
import script from "./ThreadItem.vue?vue&type=script&lang=js&"
export * from "./ThreadItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567b2b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6567b2b3')) {
      api.createRecord('6567b2b3', component.options)
    } else {
      api.reload('6567b2b3', component.options)
    }
    module.hot.accept("./ThreadItem.vue?vue&type=template&id=6567b2b3&scoped=true&", function () {
      api.rerender('6567b2b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/ThreadItem.vue"
export default component.exports